import config from '../config'
import {BASE_URL} from '../../api'
import API_LINKS from '../../constant/api.links'

const {axios} = config
const useClasses = () => {
  const getClass = async (id: any) => {
    try {
      const url = BASE_URL + API_LINKS.GET_CLASS + '/' + id
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (e: any) {
      throw new Error(e)
    }
  }

  const getUsersInClass = async (classId: string) => {
    try {
      const url = BASE_URL + API_LINKS.GET_USERS_CLASS + '/' + classId

      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (e: any) {
      throw new Error(e)
    }
  }

  const getBookingsByClassId = async (classId: string) => {
    try {
      const url = BASE_URL + API_LINKS.GET_BOOKINGS_CLASS + '/' + classId
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (e: any) {
      throw new Error(e)
    }
  }

  const editClass = async (data: any, id: string) => {
    try {
      const url = BASE_URL + API_LINKS.EDIT_CLASS + '/' + id
      const {data: response, status} = await axios.put(url, data)
      return {data: response, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const downloadClasses = async () => {
    try {
      const url = BASE_URL + API_LINKS.DOWNLOAD_CLASSES
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  return {
    getClass,
    getUsersInClass,
    getBookingsByClassId,
    editClass,
    downloadClasses,
  }
}
export default useClasses
